{
  "$schema": "./domains.schema.json",
  "version": "1.0",
  "doc": "Single source of truth for environment-specific domain URLs across local / staging / production. Consumed by start.sh (env-file generation), the marketing site's VITE_PORTAL_URL, the connectors framework's CONNECTORS_CALLBACK_ORIGIN, the playwright config's baseURL, and any other place that needs to know 'what's the portal URL in env X'. Editing this file is the canonical way to change a domain — `scripts/validate-domains.mjs` catches drift.",
  "environments": {
    "local": {
      "_note": "Local URLs are 127.0.0.1, not localhost. Vite + the Firebase emulator suite bind IPv4 explicitly (avoids IPv6 fallthrough on macOS); Playwright's baseURL also resolves through localUrl() to 127.0.0.1. The browser treats localhost and 127.0.0.1 as different origins for localStorage / cookies, so the persona storage states the seed script writes must match exactly. CORS (apps/functions/src/http/cors.ts) accepts both forms anyway, so tooling that types `localhost` by hand still works against /api.",
      "portal": "http://127.0.0.1:5180",
      "marketing": "http://127.0.0.1:5181",
      "api": "http://127.0.0.1:5001/leanopx-eos/us-central1/api",
      "connectorsCallback": "http://127.0.0.1:5001/leanopx-eos/us-central1/api",
      "contactEmail": "hello@leanopx.ai"
    },
    "staging": {
      "portal": null,
      "marketing": null,
      "api": null,
      "connectorsCallback": null,
      "_note": "Staging is not provisioned yet — Firebase project + hosting sites + custom domains TBD. Fill in when the staging Firebase project lands; until then every consumer falls back to `local` for dev runs and `production` for cloud."
    },
    "production": {
      "portal": "https://portal.leanopx.ai",
      "marketing": "https://leanopx.ai",
      "api": "https://us-central1-leanopx-eos.cloudfunctions.net/api",
      "connectorsCallback": "https://us-central1-leanopx-eos.cloudfunctions.net/api",
      "contactEmail": "hello@leanopx.ai"
    }
  }
}
